import { useState } from 'react';

const steps = [
  {
    no: '01',
    phase: 'Discovery',
    title: '需求訪談',
    duration: '1–2 週',
    icon: 'ri-chat-smile-3-line',
    summary: '深度了解品牌背景、空間需求、預算目標與業主期望',
    desc: '合作的起點，也是最重要的一步。我們透過深度訪談，全面了解你的品牌定位、目標客群、空間使用需求、預算上限與期望工期，同時釐清業主的審美偏好與品牌價值觀，確保設計方向從一開始就正確。',
    deliverables: ['需求確認表', '初步可行性評估', '合作範疇說明書'],
    keyPoints: [
      '品牌定位與目標客群釐清',
      '空間機能需求盤點',
      '預算框架初步討論',
      '工期目標確認',
    ],
    img: 'https://readdy.ai/api/search-image?query=professional%20interior%20design%20consultation%20meeting%20client%20designer%20discussing%20plans%20modern%20office%20warm%20atmosphere%20friendly%20professional%20setting&width=900&height=600&seq=proc001&orientation=landscape',
  },
  {
    no: '02',
    phase: 'Survey',
    title: '現場丈量與空間評估',
    duration: '1 週',
    icon: 'ri-ruler-2-line',
    summary: '現地勘查空間條件、結構限制與動線可行性',
    desc: '設計師親赴現場進行精確丈量，評估空間的結構限制、水電管線分布、自然採光條件，以及空間改造的技術可行性。這個階段確保後續設計方案在現實條件下能夠完整落地執行。',
    deliverables: ['現場丈量平面圖', '空間條件評估報告', '結構限制說明'],
    keyPoints: [
      '精確空間丈量記錄',
      '結構與管線評估',
      '採光與通風條件分析',
      '改造可行性確認',
    ],
    img: 'https://readdy.ai/api/search-image?query=interior%20designer%20measuring%20commercial%20space%20on-site%20survey%20empty%20store%20retail%20professional%20assessment%20tape%20measure%20floor%20plan%20sketching&width=900&height=600&seq=proc002&orientation=landscape',
  },
  {
    no: '03',
    phase: 'Concept',
    title: '平面配置與概念提案',
    duration: '2–3 週',
    icon: 'ri-draft-line',
    summary: '提出平面配置草案、設計概念方向與材料初步建議',
    desc: '基於訪談資訊與現場評估，我們提出初步平面配置方案，呈現空間功能區劃分、主要動線規劃、設計風格概念板，以及材料與色彩方向。此階段以視覺化方式讓業主具體感受空間可能性，並進行方向確認與調整。',
    deliverables: ['平面配置草圖 2–3 版', '設計概念情緒板', '初步材料方向建議'],
    keyPoints: [
      '功能區域配置方案',
      '消費動線規劃',
      '設計風格概念板呈現',
      '初步材料色彩方向',
    ],
    img: 'https://readdy.ai/api/search-image?query=interior%20design%20concept%20presentation%20mood%20board%20floor%20plan%20sketches%20material%20samples%20design%20studio%20creative%20process%20elegant%20professional&width=900&height=600&seq=proc003&orientation=landscape',
  },
  {
    no: '04',
    phase: 'Development',
    title: '設計深化與預算討論',
    duration: '3–5 週',
    icon: 'ri-pencil-ruler-2-line',
    summary: '完整施工圖、材料確認、細部設計與預算細化',
    desc: '概念確認後，進入設計深化階段。我們完成完整的施工設計圖說，包含平面圖、立面圖、天花板圖、水電圖，以及施工說明。同步進行材料樣品確認、燈光計畫細化，並提供詳細工程預算清單，讓業主在施工前對每筆費用心中有數。',
    deliverables: ['完整施工圖說（全套）', '材料樣品確認單', '詳細工程預算清單', '燈光計畫書'],
    keyPoints: [
      '全套施工圖文件',
      '材料樣品實物確認',
      '工程預算細項說明',
      '修改調整與最終確認',
    ],
    img: 'https://readdy.ai/api/search-image?query=interior%20design%20detailed%20drawings%20blueprints%20floor%20plans%20material%20samples%20swatches%20design%20development%20professional%20workspace%20organized%20documents&width=900&height=600&seq=proc004&orientation=landscape',
  },
  {
    no: '05',
    phase: 'Construction',
    title: '工程施作與進度管理',
    duration: '依工程規模',
    icon: 'ri-tools-line',
    summary: '工班協調、現場品質監控、定期工程進度回報',
    desc: '施工階段由我們統籌整合所有工班，包含泥作、木作、水電、鐵件、油漆等各項工程，進行嚴格的現場品質管理。每週提供進度報告，若遇到現場突發狀況，由設計師與工程師共同研議解決方案，確保工程品質不打折。',
    deliverables: ['每週工程進度報告', '現場施工照片記錄', '工程變更確認單'],
    keyPoints: [
      '工班整合統一管理',
      '現場品質逐項確認',
      '工期進度精確追蹤',
      '突發問題即時處理',
    ],
    img: 'https://readdy.ai/api/search-image?query=commercial%20interior%20construction%20site%20professional%20project%20manager%20overseeing%20renovation%20work%20quality%20control%20organized%20workspace%20progress%20monitoring&width=900&height=600&seq=proc005&orientation=landscape',
  },
  {
    no: '06',
    phase: 'Handover',
    title: '完工驗收與交付',
    duration: '1 週',
    icon: 'ri-checkbox-circle-line',
    summary: '逐項驗收確認、使用說明與後續維護建議',
    desc: '工程完成後，我們陪同業主進行逐項細部驗收，確認每個角落均符合設計圖說標準。提供空間設備使用說明、材料保養建議，以及後續若有局部修繕的廠商資訊。我們不只做到完工，更確保業主真正滿意再交付。',
    deliverables: ['驗收確認清單', '空間設備使用說明', '材料保養手冊', '廠商聯絡資訊'],
    keyPoints: [
      '逐項細部驗收',
      '設備使用說明講解',
      '材料保養建議提供',
      '售後諮詢服務支援',
    ],
    img: 'https://readdy.ai/api/search-image?query=completed%20luxury%20commercial%20interior%20space%20handover%20final%20inspection%20elegant%20restaurant%20or%20retail%20store%20beautiful%20finished%20result%20warm%20lighting%20professional&width=900&height=600&seq=proc006&orientation=landscape',
  },
];

export default function ProcessSteps() {
  const [activeStep, setActiveStep] = useState(0);
  const current = steps[activeStep];

  return (
    <section className="py-16 md:py-24 bg-[#fafaf8]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">

        {/* Step Navigator */}
        <div className="flex overflow-x-auto gap-0 mb-14 rounded-2xl border border-[#e2ddd8] bg-[#f4f2ef] p-1.5 scrollbar-none">
          {steps.map((s, i) => (
            <button
              key={i}
              onClick={() => setActiveStep(i)}
              className={`flex-1 min-w-[120px] flex flex-col items-center gap-1.5 px-4 py-3.5 rounded-xl transition-all duration-300 cursor-pointer ${
                activeStep === i
                  ? 'bg-[#1a1a1a] text-white'
                  : 'text-[#5a5a5a] hover:bg-white/60'
              }`}
            >
              <span
                className={`text-xs font-semibold tracking-widest ${
                  activeStep === i ? 'text-[#b8956a]' : 'text-[#b8956a]/60'
                }`}
              >
                {s.no}
              </span>
              <span className="text-sm font-medium whitespace-nowrap">{s.title}</span>
            </button>
          ))}
        </div>

        {/* Active Step Detail */}
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          {/* Left: Image + Badge */}
          <div className="lg:w-5/12 w-full">
            <div className="relative">
              <div className="w-full h-[340px] md:h-[420px] rounded-2xl overflow-hidden">
                <img
                  key={current.no}
                  src={current.img}
                  alt={current.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Phase Badge */}
              <div className="absolute -top-4 -left-4 bg-[#b8956a] text-white rounded-xl px-5 py-3">
                <div
                  className="font-bold leading-none"
                  style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '2.25rem' }}
                >
                  {current.no}
                </div>
                <div className="text-white/80 text-xs tracking-widest uppercase mt-0.5">{current.phase}</div>
              </div>
              {/* Duration Badge */}
              <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm rounded-full px-4 py-2 flex items-center gap-2">
                <i className="ri-time-line text-[#b8956a] text-sm"></i>
                <span className="text-[#1a1a1a] text-xs font-semibold">{current.duration}</span>
              </div>
            </div>

            {/* Deliverables */}
            <div className="mt-6 bg-[#f4f2ef] rounded-xl p-6">
              <h4 className="font-semibold text-[#1a1a1a] mb-4 flex items-center gap-2" style={{ fontSize: '1rem' }}>
                <i className="ri-file-list-3-line text-[#b8956a]"></i>
                本階段交付項目
              </h4>
              <ul className="space-y-2.5">
                {current.deliverables.map((d) => (
                  <li key={d} className="flex items-center gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-[#b8956a] text-sm"></i>
                    </div>
                    <span className="text-[#5a5a5a] text-sm">{d}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:w-7/12 w-full">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 flex items-center justify-center bg-[#b8956a]/10 rounded-xl">
                <i className={`${current.icon} text-[#b8956a] text-xl`}></i>
              </div>
              <div>
                <p className="text-xs text-[#b8956a] uppercase tracking-widest font-medium">{current.phase}</p>
                <h2
                  className="font-bold text-[#1a1a1a] leading-snug"
                  style={{ fontSize: 'clamp(1.375rem, 2.5vw, 1.875rem)' }}
                >
                  {current.title}
                </h2>
              </div>
            </div>

            <p className="text-[#b8956a] font-medium mb-4" style={{ fontSize: '1rem' }}>
              {current.summary}
            </p>

            <p className="text-[#5a5a5a] leading-[1.75] mb-8" style={{ fontSize: '1.1875rem' }}>
              {current.desc}
            </p>

            {/* Key Points */}
            <div className="mb-8">
              <h4 className="font-semibold text-[#1a1a1a] mb-4" style={{ fontSize: '1rem' }}>
                本階段重點工作
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {current.keyPoints.map((kp, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-3 p-4 bg-[#f4f2ef] rounded-xl"
                  >
                    <div className="w-7 h-7 flex items-center justify-center bg-[#b8956a]/15 rounded-lg flex-shrink-0">
                      <span className="text-[#b8956a] text-xs font-bold">{String(i + 1).padStart(2, '0')}</span>
                    </div>
                    <span className="text-[#3a3a3a] text-sm">{kp}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Prev / Next */}
            <div className="flex items-center gap-4">
              <button
                onClick={() => setActiveStep((p) => Math.max(0, p - 1))}
                disabled={activeStep === 0}
                className="flex items-center gap-2 px-5 py-2.5 border border-[#e2ddd8] text-[#5a5a5a] rounded-full text-sm font-medium disabled:opacity-30 hover:bg-[#f4f2ef] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-left-line"></i>
                上一步
              </button>
              <button
                onClick={() => setActiveStep((p) => Math.min(steps.length - 1, p + 1))}
                disabled={activeStep === steps.length - 1}
                className="flex items-center gap-2 px-5 py-2.5 bg-[#1a1a1a] text-white rounded-full text-sm font-medium disabled:opacity-30 hover:bg-[#333] transition-colors cursor-pointer whitespace-nowrap"
              >
                下一步
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
